import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { shippingShippingOptionsPresentedInCheckoutCartSrc130Evid183, shippingShippingOptionsSelectedSrc130Evid186 } from '@wix/bi-logger-ecom-platform-data/v2';
const origin = 'checkout';
export class BIService {
  constructor(controllerConfig) {
    var _fixOldLoggerFactoryD, _controllerConfig$pla, _controllerConfig$pla2;
    _defineProperty(this, "logger", void 0);
    const loggerFactory = controllerConfig.platformAPIs.biLoggerFactory == null ? void 0 : controllerConfig.platformAPIs.biLoggerFactory();
    if (!loggerFactory) {
      return;
    }
    this.logger = (_fixOldLoggerFactoryD = fixOldLoggerFactoryDueToWorkerYoshiV4(loggerFactory)) == null || (_fixOldLoggerFactoryD = _fixOldLoggerFactoryD.updateDefaults({
      bi_token: (_controllerConfig$pla = controllerConfig.platformAPIs.bi) == null ? void 0 : _controllerConfig$pla.biToken,
      appName: 'DeliverySectionCheckout',
      _msid: (_controllerConfig$pla2 = controllerConfig.platformAPIs.bi) == null ? void 0 : _controllerConfig$pla2.metaSiteId
    })) == null ? void 0 : _fixOldLoggerFactoryD.logger();
  }
  async shippingOptionsPresentedInCheckout(purchaseFlowId, checkoutId, cartId, deliveryOptions, hasPartialShippingOptions) {
    var _this$logger;
    (_this$logger = this.logger) == null || _this$logger.report == null || _this$logger.report(shippingShippingOptionsPresentedInCheckoutCartSrc130Evid183({
      origin,
      checkoutId,
      cartId,
      purchaseFlowId,
      shippingOptionsPresented: JSON.stringify(deliveryOptions),
      numOptionsPresented: deliveryOptions == null ? void 0 : deliveryOptions.length,
      isPartial: hasPartialShippingOptions
    }));
  }
  async shippingOptionSelected(purchaseFlowId, checkoutId, cartId, deliveryOptions, selectedShippingOption, hasPartialShippingOptions, shippingOptionIndex) {
    var _this$logger2;
    (_this$logger2 = this.logger) == null || _this$logger2.report == null || _this$logger2.report(shippingShippingOptionsSelectedSrc130Evid186({
      origin,
      checkoutId,
      cartId,
      purchaseFlowId,
      shippingOptionId: selectedShippingOption,
      numOptionsPresented: deliveryOptions == null ? void 0 : deliveryOptions.length,
      shippingOptionsPresented: JSON.stringify(deliveryOptions),
      isPartial: hasPartialShippingOptions,
      shippingOptionIndex
    }));
  }
}
function fixOldLoggerFactoryDueToWorkerYoshiV4(factory) {
  if (factory.factory) {
    return factory.factory();
  }
  return factory;
}
//# sourceMappingURL=BIService.js.map